import { Injector } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ContextDroitsModel } from '../../models/menu/context-droits.model';
import { MenuItemModel } from '../../models/menu/menu-item.model';
import { MenuItemAggregate } from './menu-item.aggregate';

export class MenuItemsAggregate {
  constructor(
    private builder: ((injector: Injector) => Observable<MenuItemAggregate[]>) | MenuItemAggregate[]
  ) {}

  buildMenuFromContext(context: ContextDroitsModel): Observable<MenuItemModel[]> {
    const items$ = Array.isArray(this.builder)
      ? of(this.builder)
      : this.builder(context.injectorContext)

      return items$.pipe(
        switchMap(items =>
          forkJoin(
            items.map(item =>
              item.buildMenuItemFromContext(context)
            )
          )
        )
      );

  }
}

